export default window._cmsContent['solar/contact-details']